import { useCallback, useEffect, useMemo, useState } from "react";
import { isDefaultOptionEqualToValue } from "../utils/defaultIsOptionEqualToValue.js";
function useOptions(options, value, getOptionDisabled, isOptionEqualToValue) {
  const valueAsSet = useMemo(() => new Set(value), [value]);
  const [visibleOptions, setVisibleOptions] = useState(options);
  const isSelected = useCallback(
    (option) => {
      if (isDefaultOptionEqualToValue(isOptionEqualToValue)) {
        return valueAsSet.has(option);
      }
      return value.some((item) => isOptionEqualToValue(item, option));
    },
    [isOptionEqualToValue, value, valueAsSet]
  );
  const [selectableOptions, setSelectableOptions] = useState(() => {
    return visibleOptions.filter((option) => !isSelected(option) && !getOptionDisabled(option));
  });
  useEffect(() => {
    setVisibleOptions(options);
  }, [options]);
  useEffect(() => {
    isOptionEqualToValue;
    value;
    setSelectableOptions(visibleOptions.filter((option) => !isSelected(option) && !getOptionDisabled(option)));
  }, [getOptionDisabled, visibleOptions, value, isOptionEqualToValue, isSelected]);
  const selectedOptions = useMemo(
    () => visibleOptions.reduce((acc, option) => {
      if (isSelected(option)) acc.push(option);
      return acc;
    }, []),
    [visibleOptions, isSelected]
  );
  return {
    visibleOptions,
    selectedOptions,
    selectableOptions,
    setVisibleOptions
  };
}
export {
  useOptions
};
//# sourceMappingURL=useOptions.js.map
